import { Form } from "formik";
import * as yup from "yup";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikDatePicker from "../../../commons/formik/formikDatePicker";
import FormikForm from "../../../commons/formik/formikForm";
import { StyledForm } from "../../../styled/form";
import { StyledPaper } from "../../../styled/paper";

yup.setLocale({
    mixed: {
        notType: 'Campo inválido'
    }
});


const validationSchema = yup.object().shape({
    fechaDesde: yup
        .date()
        .required('Campo obligatorio')
        .typeError('Campo obligatorio')
        .test('fecha-desde-before-hasta', 'La fecha desde debe ser anterior o igual a la fecha hasta',
            function (value) {
                const { fechaHasta } = this.parent;
                if (!value || !fechaHasta) return true;
                return new Date(value) <= new Date(fechaHasta);
            }
        ),
    fechaHasta: yup
        .date()
        .required('Campo obligatorio')
        .typeError('Campo obligatorio')
        .test('fecha-hasta-after-desde', 'La fecha hasta debe ser posterior o igual a la fecha desde',
            function (value) {
                const { fechaDesde } = this.parent;
                if (!value || !fechaDesde) return true;
                return new Date(value) >= new Date(fechaDesde);
            }
        ),
    art: yup
        .string()
        .required('Campo obligatorio'),
});

const initialValues = {
    art: '',
    provider: '',
    fechaDesde: null,
    fechaHasta: null,
};

const ProviderStatsSearchComponent = ({
    handleSearch,
    handleReset,
    art,
    providers,
    onArtChange
}) => {

    const handleOnArtChange = (artValue, setFieldValue) => {
        onArtChange(artValue);
        setFieldValue("provider", null);
    }

    return (
        <div>
            <StyledPaper.Container>
                <FormikForm
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={values => handleSearch(values.art, values.provider, values.fechaDesde, values.fechaHasta)}>
                    {({ values, handleSubmit, setFieldValue, errors, isValid, dirty }) => (
                        <>
                            <Form>
                                <StyledForm.Input>
                                    <FormikAutocomplete
                                        options={art || []}
                                        name="art"
                                        label="Art *"
                                        variant="standard"
                                        callBack={(value) => handleOnArtChange(value, setFieldValue)}
                                    />
                                </StyledForm.Input>

                                <StyledForm.Input>
                                    <FormikAutocomplete
                                        options={providers || []}
                                        name="provider"
                                        label="Prestador"
                                        variant="standard"
                                    />
                                </StyledForm.Input>

                                <StyledForm.Input>
                                    <FormikDatePicker
                                        variant="standard"
                                        name="fechaDesde"
                                        label="Fecha Desde *"
                                        inputFormat="DD/MM/YYYY"
                                        views={["year", "month", "day"]}
                                        disableFuture
                                    />
                                </StyledForm.Input>

                                <StyledForm.Input>
                                    <FormikDatePicker
                                        variant="standard"
                                        name="fechaHasta"
                                        label="Fecha Hasta *"
                                        inputFormat="DD/MM/YYYY"
                                        views={["year", "month", "day"]}
                                        disableFuture
                                    />
                                </StyledForm.Input>
                            </Form>

                            <StyledForm.ButtonContainer>
                                <StyledForm.Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    onClick={handleSubmit}
                                    disabled={!isValid || !dirty}>
                                    Buscar
                                </StyledForm.Button>
                            </StyledForm.ButtonContainer>

                            <StyledForm.ButtonContainer>
                                <StyledForm.Button
                                    variant="contained"
                                    type="reset"
                                    color="primary"
                                    onClick={() => {
                                        setFieldValue("fechaDesde", initialValues.fechaDesde);
                                        setFieldValue("fechaHasta", initialValues.fechaHasta);
                                        setFieldValue("art", initialValues.art);
                                        setFieldValue("provider", initialValues.provider);
                                        handleReset();
                                    }}>
                                    Limpiar
                                </StyledForm.Button>
                            </StyledForm.ButtonContainer>
                        </>
                    )}
                </FormikForm>
            </StyledPaper.Container>
        </div >
    );
};

export default ProviderStatsSearchComponent;
